export var SliderStyles = function (props) {
    var disabled = props.disabled, theme = props.theme;
    var palette = theme.palette;
    return {
        activeSection: [
            disabled && {
                background: palette.neutralTertiary,
            },
        ],
    };
};
//# sourceMappingURL=Slider.styles.js.map